import {react,useState,useEffect} from 'react'
import "./css/Gallery.css"


const Gallery = () => {
const [imageGroups, setImageGroups] = useState([]);

  const [sliderdata,setSliderdata]=useState('')
  const [loading,setLoading] = useState('loading')
  const [content, setContent] = useState([
    {
      image: "/images1/KB1.JPG",
      alt: "Third slide",
      heading: "Third slide",
      paragraph:
        "Since its inception, HIS has consistently grown year after year and has gained a reputation of becoming a leading educational institute.",
      captionStyle: {},
    },
  ]);



useEffect(() => {
  console.log(process.env.REACT_APP_BASE_URL)
  const fetchGalleryImages = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PROJECT_PATH}/items/gallery?fields=*.*.*`,
        {
          cache: "no-store",
        }
      );
      const result = await response.json();

      // Extract all image URLs
      const images = (result.data || [])
        .map(item =>
          item.gallery_images?.data?.full_url
            ? item.gallery_images.data.full_url.replace("http://", "https://")
            : null
        )
        .filter(Boolean); // remove nulls if any

      // Group them into chunks of 4 images per row
      const chunkSize = 4;
      const groupedImages = [];
      for (let i = 0; i < images.length; i += chunkSize) {
        groupedImages.push(images.slice(i, i + chunkSize));
      }

      setImageGroups(groupedImages);
    } catch (err) {
      console.error("Error fetching gallery images:", err);
    }
  };

  fetchGalleryImages();
}, []);
useEffect(() => {
//   console.log("Updated content:", content);
}, [content]);
  
  


  return (
    <>
<div className="container-fluid">
  {imageGroups.map((group, groupIndex) => (
    <div className="first" key={groupIndex}>
      {group.map((src, imgIndex) => (
        <div className="one" key={imgIndex}>
          <img src={src} alt="" />
        </div>
      ))}
    </div>
  ))}
</div>

    </>
  )
}

export default Gallery